import { InjectionToken } from '@angular/core';

export interface MessagingConfig {
  aiChatUserId: number;
}

export const MESSAGING_CONFIG = new InjectionToken<MessagingConfig>(
  'messaging',
);
